import { Record, List } from 'immutable';
import InventoryRecord from './InventoryRecord';
import PhotoHash from './PhotoHash';

const CollectionItemDefaults = {
  inventory_record: null
};

class CollectionItem extends Record(CollectionItemDefaults) {
  constructor(values) {
    values.inventory_record = new InventoryRecord(values.inventory_record);

    super(values);
  }
}

const CollectionDefaults = {
  id: null,
  title: '',
  description: '',
  slug: null,
  cover_photo_hash: null,
  items: new List(),
  store_id: null,
  is_private: null,
  published_at: ''
};

class Collection extends Record(CollectionDefaults) {
  constructor(values) {
    values.cover_photo_hash = (values.cover_photo_hash instanceof PhotoHash) ? values.cover_photo_hash : new PhotoHash(values.cover_photo_hash);
    values.items = (new List(values.items)).map((item) => {return (item instanceof CollectionItem ? item : new CollectionItem(item));});

    super(values);
  }
}

export default Collection;



// WEBPACK FOOTER //
// banquet/models/Collection.js